export default __webpack_public_path__ + "static/media/benefits_automatesavingicon.61de4fc7.svg";